import * as React from "react";

import * as PropTypes from 'prop-types';
import {
    Container,
} from "react-pixi-fiber";
  
export interface IZoomProps {
    offsetX: number,
    zoom: number,
}

interface IProps {
    children: React.ReactNode[],
    height: number,
    offsetX: number,
    offsetY: number,
    duration: number | null,
    onClick: (t: number) => void,
    onZoom: (zoom: IZoomProps) => void,
    width: number,
    zoom: number,
}

interface IContext {
    app?: PIXI.Application,
}

export interface IBounds {
    min: {
        x: number,
        y: number,
    },
    max: {
        x: number,
        y: number,
    },
}

export class Scaler extends React.Component<IProps> {

    public static contextTypes = {
        app: PropTypes.object,
    };
    public bounds: IBounds | null = null;

    private container: PIXI.Container | null;
    private scale: PIXI.Point;
    private position: PIXI.Point;

    constructor(props: IProps) {
        super(props);

        this.scale = new PIXI.Point(props.zoom, 1);
        this.position = new PIXI.Point(props.offsetX, props.offsetY);
    }

    public render() {
        const {
            children,
        } = this.props;
        return (
            <Container
                // PERF(): don't reallocate here
                position={this.position}
                scale={this.scale}
                interactive={true}
                ref={this.onMount}>
                { children }
            </Container>
        )
    }

    public componentWillReceiveProps(props: IProps) {
        const {
            offsetX,
            offsetY,
            zoom,
        } = props;
        
        if (offsetX !== this.props.offsetX) {
            this.position = new PIXI.Point(offsetX, offsetY);
        }
        if (zoom !== this.props.zoom) {
            this.scale = new PIXI.Point(zoom, 1);
        }

        this.bounds = this.getBounds();
    }

    public onWheel(e: React.WheelEvent<any>) {
        const { app }: IContext = this.context;
        if (!app) {
            return;
        }
        const {renderer} = app;

        const {
          duration,
          offsetX,
          onZoom,
          width,
          zoom,
        } = this.props;
    
        if (e.ctrlKey) {
          const scaleFactor = (zoom - e.deltaY) / zoom;
    
          if (zoom * scaleFactor > 300) {
            return;
          }

          let minScale = 0.1;
          if (duration && duration > 0) {
              // If the whole clip is visible don't let them zoom further
              minScale = width / (duration * 1.05);
          }
          if (zoom * scaleFactor < minScale) {
            return;
          }
    
          const interaction = renderer.plugins.interaction;
          const anchor = new PIXI.Point(0, 0);
          interaction.mapPositionToPoint(anchor, e.clientX, e.clientY);
    
          onZoom({
            offsetX: offsetX * scaleFactor + anchor.x * (1 - scaleFactor),
            zoom: zoom * scaleFactor
          });
        } else {
    
            onZoom({
            offsetX: offsetX - e.deltaX * 2,
            zoom,
          });
        }
    }

    public getBounds(): IBounds | null {
        if (!this.container) { return null; }

        const {
            width,
            height
        } = this.props;

        const min = this.container.toLocal(new PIXI.Point(0, 0));
        const max = this.container.toLocal(new PIXI.Point(width, height));

        return {
            max,
            min,
        };
    }

    private onMount = (ref: any) => {
        // HACK
        const scaler = ref as (PIXI.Container | null);
        if (!scaler) { return; }

        this.container = scaler;

        scaler.on('mousedown', this.onClick);
    }

    private onClick = (e: PIXI.interaction.InteractionEvent) => {
        if (!this.container) {
            return;
        }

        const playPosition = e.data.getLocalPosition(this.container);
        const t = playPosition.x;

        this.props.onClick(t);
    }

}

export default Scaler;



// WEBPACK FOOTER //
// ./src/components/Player/Scaler.tsx